import { FC, useEffect, useState } from "react";
import {
  centsToFloat,
  floatToPercent,
  floatToPrice,
  isNumber,
} from "../../functions/price_functions";
import styles from "./index.module.css";
import { datetimeToDatetimeBR, maskCardNumber } from "../../functions/mask";
// icones
import visaLogo from "../../assets/images/visa.svg";
import ticketLogo from "../../assets/images/ticket.svg";
import masterCardLogo from "../../assets/images/masterCard.svg";
import redeLogo from "../../assets/images/rede.svg";
import aleloLogo from "../../assets/images/alelo.svg";
import americaExpressLogo from "../../assets/images/americanExpress.svg";
import eloLogo from "../../assets/images/elo.svg";
import hiperCardLogo from "../../assets/images/hipercard.svg";
import maestroLogo from "../../assets/images/maestro.svg";
import { CiDiscount1 } from "react-icons/ci";
import { IntegrationType } from "../../contexts/orderMetaDataContext/orderMetaData.type";

interface DataGateway {
  code: number;
  capture: Capture;
  typeTicket: string;
  payment_id: string;
  cardTicket: string;
  statuscapture: number;
  payment: Payment;
  orderDate: string;
  status: string;
  nwr: string;
  hashc: string;
  vay: string;
  paymentType: number;
  ctk: string;
  gatewayName: string;
  value: number;
  portion_numInstallments: number;
  flagIdentifier: string;
  authorization: string;
  networkIdentifier: string;
  pluginspaceId: number;
  pluginconfigId: number;
  gatewayId: number;
  refundFlag: string;
  ip: string;
  codePay: string;
  orderIdExt: number;
  descConditionpay: string;
  paymentTermCode: number;
  bin: string;
  end: string;
  paymentData: IntegrationType | null;
}

interface Payment {
  order_id: number;
  orderDate: string;
  merchant_usn: number;
  nsu: number;
  customer_receipt: Customerreceipt;
  receipt: Customerreceipt;
}

interface Customerreceipt {
  customer_receipt: string;
  merchant_receipt: string;
}

interface Capture {
  Status: number;
  ReasonCode: number;
  ReasonMessage: string;
  ProviderReturnCode: string;
  ProviderReturnMessage: string;
  ReturnCode: string;
  ReturnMessage: string;
  Tid: string;
  ProofOfSale: string;
  AuthorizationCode: string;
  Content: Content;
  success: boolean;
}

interface Content {
  Status: number;
  ReasonCode: number;
  ReasonMessage: string;
  ProviderReturnCode: string;
  ProviderReturnMessage: string;
  ReturnCode: string;
  ReturnMessage: string;
  Tid: string;
  ProofOfSale: string;
  AuthorizationCode: string;
  Links: Link[];
}

interface Link {
  Method: string;
  Rel: string;
  Href: string;
}

export type OrderIntegrationPlanType = {
  codePay: string;
  codePlan: number;
  nameGateway: string;
  paymentItemData: IntegrationType;
  nameBrand?: string;
  typePayment?: any;
};

type Props = {
  gateWay: DataGateway;
  changePaymentValue: number;
  cupomDiscount?: string;
  paymentDiscount?: { type: string; discountValue: string } | null | undefined;
  installment?: number;
  installmentValue?: number;
  integrationPlanLocal?: OrderIntegrationPlanType;
};

const InfoPayment: FC<Props> = ({
  gateWay,
  changePaymentValue,
  cupomDiscount,
  paymentDiscount,
  installment,
  installmentValue,
  integrationPlanLocal,
}) => {
  const [showChange, setShowChange] = useState(false);

  function paymentType(cardTicket: string) {
    switch (cardTicket) {
      case "App":
        return "Pagamento na Entrega";
      default:
        return `Cartão ${cardTicket}`;
    }
  }

  const trunCat = (num: number, decimals: number) => {
    const formatter = Math.pow(10, decimals);
    const res = Math.floor(num * formatter) / formatter;
    return res;
  };

  function floatToPrice(value: number): string {
    return value.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  }

  function cardIcon(cardBrand: string) {
    switch (cardBrand) {
      case "visa":
        return (
          <img
            src={visaLogo}
            style={{
              width: "32px",
              height: "auto",
            }}
          />
        );

      case "mastercard":
        return (
          <img
            src={masterCardLogo}
            style={{
              width: "32px",
              height: "auto",
            }}
          />
        );
      case "americanexpress":
        return (
          <img
            src={americaExpressLogo}
            style={{
              width: "32px",
              height: "auto",
            }}
          />
        );
      case "elo":
        return (
          <img
            src={eloLogo}
            style={{
              width: "32px",
              height: "auto",
            }}
          />
        );
      case "hipercard":
        return (
          <img
            src={hiperCardLogo}
            style={{
              width: "32px",
              height: "auto",
            }}
          />
        );
      case "maestro":
        return (
          <img
            src={maestroLogo}
            style={{
              width: "32px",
              height: "auto",
            }}
          />
        );
      case "rede":
        return (
          <img
            src={redeLogo}
            style={{
              width: "32px",
              height: "auto",
            }}
          />
        );
      case "ticket":
        return (
          <img
            src={ticketLogo}
            style={{
              width: "32px",
              height: "auto",
            }}
          />
        );
      case "alelo":
        return (
          <img
            src={aleloLogo}
            style={{
              width: "32px",
              height: "auto",
            }}
          />
        );
      default:
        return (
          <>
            <div
              style={{
                width: "32px",
                height: "auto",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <i
                className="fa fa-credit-card"
                style={{
                  color: "#3C9EE5",
                }}
              />
            </div>
          </>
        );
    }
  }

  function shouldShowChange() {
    if (changePaymentValue && changePaymentValue > 0) {
      setShowChange(true);
    }
  }

  function getPaymentType(typePay: string) {
    switch (typePay.toLowerCase()) {
      case "debit":
        return "Cartão de débito - ";
      case "credit":
        return "Cartão de crédito - ";
      default:
        return "";
    }
  }

  useEffect(() => {
    shouldShowChange();
  }, []);

  return (
    <div className={styles.content}>
      <h4>Pagamento</h4>
      <span>
        {" "}
        {gateWay?.gatewayName !== "App" && cardIcon(gateWay.typeTicket)}{" "}
        {paymentType(gateWay?.gatewayName)}
      </span>
      {gateWay?.gatewayName === "App" && gateWay.paymentData && (
        <>
          <span>
            {getPaymentType(gateWay.paymentData.typePay)}{" "}
            {gateWay.paymentData.brand.toUpperCase()}
          </span>
        </>
      )}
      {gateWay?.gatewayName !== "App" && (
        <span>
          Final{" "}
          {maskCardNumber(
            gateWay.cardTicket
              ? gateWay.cardTicket
              : gateWay.ctk
              ? gateWay.ctk
              : ""
          )}
        </span>
      )}
      <span>Realizado em {datetimeToDatetimeBR(gateWay.orderDate)}</span>

      {showChange && (
        <span>
          {"Troco para: "}{" "}
          {floatToPrice(changePaymentValue + centsToFloat(gateWay.value))}
        </span>
      )}
      <span>Total {floatToPrice(centsToFloat(gateWay.value))} </span>
      {integrationPlanLocal &&
        (integrationPlanLocal.typePayment === "card" ||
          integrationPlanLocal.typePayment === "others") && (
          <span>
            {"Parcelas: "} {installment || 1}x{" "}
            {floatToPrice(trunCat(installmentValue || 0, 2))}
          </span>
        )}

      {paymentDiscount &&
        paymentDiscount.discountValue &&
        paymentDiscount.type && (
          <span style={{ display: "flex", alignItems: "center", gap: "4px" }}>
            Desconto por Meio de Pagamento :{" "}
            <b>
              {" "}
              {paymentDiscount.type === "percentage"
                ? floatToPercent(parseFloat(paymentDiscount.discountValue))
                : floatToPrice(parseFloat(paymentDiscount.discountValue))}{" "}
            </b>
            <CiDiscount1 size="20px" color="#6E7586" />
          </span>
        )}

      {cupomDiscount && (
        <span style={{ display: "flex", alignItems: "center", gap: "4px" }}>
          {" "}
          Cupom: <b> {cupomDiscount}</b>{" "}
          <CiDiscount1 size="20px" color="#6E7586" />{" "}
        </span>
      )}
    </div>
  );
};

export { InfoPayment };
